/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1265
 */

var r = require(/* 194 */"../1648/194")
module.exports = r.Promise
